<template>
<div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-row class="bradcrumb">
        <router-link :to="{name: 'role-links' }" class="root">
            Dashboard
        </router-link>
        <span class="child">/ Question Bank Status</span>
    </v-row><br />
    <center class="heading">
        <h2>Question Bank Status</h2>
    </center>
    <br />
    <v-container fluid style="padding:0">
        <v-card class="mx-auto main" max-width="auto" height="" outlined>
        <div class="box">
            <v-row>
                <v-col xs="12" sm="12" lg="3" md="6" cols="12">
                    <label class="bold">Program Type</label>
                    <v-autocomplete :items="progt_list" item-value="id" class="select" placeholder="Select Program Type" item-text="name" v-model="selected_prog" @change="findprogtype()" :rules="[v => !!v || 'required']" dense outlined></v-autocomplete>
                </v-col>

                <v-col xs="12" sm="12" lg="3" md="6" cols="12">
                    <label class="bold">Program</label>
                    <v-autocomplete :items="progtype_list" item-value="id" class="select" placeholder="Select Program" item-text="name" v-model="selected_prog_type" dense outlined></v-autocomplete>
                </v-col>

                <v-col xs="12" sm="12" lg="3" md="6" cols="12">
                    <label class="bold">Year</label>
                    <v-autocomplete :items="year_list" item-value="id" class="select" placeholder="Select Year" item-text="name" v-model="year_data" @change="findsubject()" dense outlined></v-autocomplete>
                </v-col>

                <v-col xs="12" sm="12" lg="3" md="6" cols="12">
                    <label class="bold">Subject</label>
                    <v-autocomplete :items="sub_list" item-value="id" item-text="course_name" class="select" placeholder="Select Subject" v-model="selected_subject" dense outlined></v-autocomplete>
                </v-col>
            </v-row>
            <v-card-actions v-if="selected_prog && selected_prog_type && year_data && selected_subject" class="justify-center">
                <v-btn @click="findsubjectauthority" class="mb-2 button btn">Fetch</v-btn>
            </v-card-actions>
        </div>
        <!-- <div class="container" style="display: flex;">
             <div style="flex: 50%;" class="column">
                <v-btn style="float: right;" class="button" @click="findsubjectauthority">Fetch</v-btn>
            </div>
            <div style="flex: 50%;" class="column">
                <v-btn style="float: right;" class="button" @click="fetch_complete_list">Fetch All</v-btn>
            </div>
        </div> -->
        <!-- <center> -->
            <template>
                <div class="container" style="display: flex;">
                    <!-- <v-row>
                        <v-checkbox v-model="selected_all" @change="getallrecords()" class="mx-2" label="All"></v-checkbox>
                        <v-checkbox v-model="selected_approved" @change="getallrecords()" class="mx-2" label="Approved"></v-checkbox>
                        <v-checkbox v-model="selected_notapproved" @change="getallrecords()" class="mx-2" label="Not Approved"></v-checkbox>
                    </v-row> -->
                    <!-- <v-row>
                        <input type="radio" name="radio" value="selected_all" @change="getallrecords('selected_all')"> All&nbsp;
                        <input type="radio" name="radio" value="selected_approved" @change="getallrecords('selected_approved')"> Approved&nbsp;
                        <input type="radio" name="radio" value="selected_notapproved" @change="getallrecords('selected_notapproved')"> Not Approved
                    </v-row> -->
                    <!-- <div style="flex: 50%;" class="column" v-if="flag_for_radio_group">
                        <table>
                            <tr>
                                <td><input type="radio" name="radio" value="selected_all" @change="getallrecords('selected_all')"> All&nbsp;</td>
                                <td>&nbsp;</td>
                                <td><input type="radio" name="radio" value="selected_approved" @change="getallrecords('selected_approved')"> Approved&nbsp;</td>
                                <td>&nbsp;</td>
                                <td><input type="radio" name="radio" value="selected_notapproved" @change="getallrecords('selected_notapproved')"> Not Approved</td>
                                <td>&nbsp;</td>
                            </tr>
                        </table>
                    </div> -->
                    <div style="flex: 50%;" class="column">
                        <v-tooltip left>
                            <template v-slot:activator="{ on }">
                                <v-btn style="float: right;" class="button" v-on="on" @click="fetch_complete_list">Fetch All</v-btn>
                            </template>
                            <span>Only Approved list will be fetched!</span>
                        </v-tooltip>
                    </div>
                </div>    
            </template>
        <!-- </center> -->
        <!--{{auth_inst_data}}<br/>
        {{auth_levels}}-->
        <template v-if="auth_inst_data!=null">
            <div class="box">
                <v-toolbar flat color="white">
					<v-toolbar-title>Question Bank Status</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <span class="column" v-if="flag_for_radio_group">
                        <table>
                            <tr>
                                <td><input type="radio" name="radio" value="selected_all" @change="getallrecords('selected_all')"> All&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td><input type="radio" name="radio" checked="checked" id ="radio_selected" value="selected_approved" @change="getallrecords('selected_approved')"> Approved&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td><input type="radio" name="radio" value="selected_notapproved" @change="getallrecords('selected_notapproved')"> Not Approved</td>
                            </tr>
                        </table>
                    </span>
                </v-toolbar>
            <v-simple-table v-if="auth_inst_data!=''">
                <tr>
                    <th class="text-left">Program Type</th>
                    <th class="text-left">Program</th>
                    <th class="text-left">Year</th>
                    <th class="text-left">Subject</th>
                    <th class="text-left">Is Approved</th>
                    <th class="text-left" v-for="all in auth_levels" :key="all">
                        {{all}}
                    </th>
                    <th class="text-left">Details</th>
                </tr>

                <tr v-for="au in auth_inst_data" :key="au">
                    <td>{{au.progtype}}</td>
                    <td>{{au.progname}}</td>
                    <td>{{au.year}}</td>
                    <td>{{au.course}}</td>
                    <td>
                        <span v-if="au.status==true">
                            <v-icon class="mr-2" color="success">mdi-check-circle-outline</v-icon>
                        </span>
                        <span v-else>
                            <v-icon class="mr-2" color="error">mdi-close-circle-outline</v-icon>
                        </span>
                    </td>
                    {{au.booleanval}}
                    <td v-for="al in au.authlist.booleanval" :key="al">
                        <template v-if="al == true">
                            <v-icon color="success" class="mr-2">mdi-check-circle-outline</v-icon>
                        </template>
                        <template v-else>
                            <v-icon color="error" class="mr-2">mdi-close-circle-outline</v-icon>
                        </template>
                    </td>
                    <td>
                        <!-- <v-btn @click="getdetails(au.id)" v-model="details_id"><i class="mdi mdi-eye eye" style="font-size:30px;color:hsla(190, 99%, 30%, 1)"></i></v-btn> -->
                        <i class="mdi mdi-eye eye" style="font-size:30px;color:hsla(190, 99%, 30%, 1)" @click="getdetails(au.id)"></i>
                    </td>
                </tr>
            </v-simple-table>
            </div>
        </template>
        <br>
        <!-- <div v-if="this.show_detail == true">
            <v-row style="padding:8px" justify="center">
                <v-col lg="6">
                    <div class="text-center card" v-if="this.instructor_data">
                        <p class="h-text">Allocation Data</p>
                        <div class="text-left" v-if="instructor_data.length > 0">
                        <v-col v-for="ins in this.instructor_data" style="padding:0;" :key="ins">
                                <div v-if="ins.authority" class="chip">
                                    <p class="authlevel"> {{ins.authority}}</p>
                                    <p v-for="(name,index) in ins.data"
                                            style="padding:0;margin:0" :key="index">
                                        <span class="inst-info">{{ name.insname }}</span>
                                        </p>
                                </div>
                            </v-col>
                        </div>
                        <div v-else>
                        <span>No Previous Allocation Data!!</span>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div> -->


        <!-- <div v-if="this.show_detail == true">
            <template v-if="courseauthority!=null"><br>
                <v-simple-table style="bordered">
                    <tr>
                        <th class="text-left" v-for="al in courseauthoritylevels" :key="al">
                            {{al}}
                        </th>

                    </tr>
                    <tr>
                        <td v-for="au in courseauthority" :key="au.name">
                            {{au}}
                        </td>

                    </tr>

                </v-simple-table>

            </template>
        </div> -->
        </v-card>
    </v-container>
    <template v-if="auth_inst_data != null">
			<template>
				<v-dialog v-model="dialog" scrollable max-width="600px">
					<v-card>
						<v-card-title class="heading">Question Bank Status</v-card-title>
						<v-divider></v-divider>
						<v-card-text style="height: 300px;">
							<div v-if="this.show_detail == true">
								<v-row style="padding:8px" justify="center">
									<v-col>
										<div class="text-center card" v-if="this.instructor_data">
											<div class="text-left" v-if="instructor_data.length > 0">
												<v-col
													v-for="ins in this.instructor_data"
													style="padding:0;"
													:key="ins"
												>
													<div v-if="ins.authority" class="chip">
														<p class="authlevel">{{ ins.authority }}</p>
														<p
															v-for="(name, index) in ins.data"
															style="padding:0;margin:0"
															:key="index"
														>
															<span class="inst-info">{{ name.insname }}</span>
														</p>
													</div>
												</v-col>
											</div>
											<div v-else>
												<span style="color:red"
													>No appointment done for selected course!!</span
												>
											</div>
										</div>
									</v-col>
								</v-row>
							</div>
						</v-card-text>
						<v-divider></v-divider>
						<v-card-actions class="justify-center">
							<v-btn class="button" text @click="dialog = false">Close</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</template>
		</template>
</div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
        instructor_data:null,
        booleanval: [],
        show_detail: false,
        snackbar_msg: "",
        snackbar: false,
        color: "",
        org: null,
        search: '',
        edit_btn_load: false,
        selected_prog: '',
        fetch_org_load: false,
        selected_prog_type: '',
        selected_subject: '',
        year_data: '',
        dialog: false,
        selected: '',
        selected_all: false,
        selected_approved: false,
        selected_notapproved: false,
        details_id: '',
        courseauthority: '',
        courseauthoritylevels: '',
        //selected_employee:'',
        //
        //selected_employee:null,
        authlevelname: null,
        progt_list: null,
        progtype_list: null,
        year_list: null,
        sub_list: null,
        auth_levels: null,
        authority_data: null,
        instructor_list: null,
        course_auth_level: null,
        auth_inst_data: null,
        courseauthority: null,
        courseauthoritylevels: null,
        radioGroup:1,
        flag_for_radio_group:false
        // editedIndex: -1,
        // editedItem: {
        //     prog_type: '',
        //     program: '',
        //     year: '',
        //     course: '',
        //     language: '',
        // },
        // defaultItem: {
        //     prog_type: '',
        //     program: '',
        //     year: '',
        //     course: '',
        //     language: '',
        //     //selected_checkbox:true,
        // },
    }),
    // computed: {
    //     formTitle() {
    //         return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    //     },
    // },

    // watch: {
    //     dialog(val) {
    //         val || this.close()
    //     },
    // },

    methods: {
        fetch_complete_list(){
            this.flag_for_radio_group = true
            axios
            .post("/Examination/fetch_full_list_QB_status")
            .then(res => {
                if(res.data.auth_data.length != 0){
                    this.auth_inst_data = res.data.auth_data
                } else{
                    this.auth_inst_data = res.data.auth_data
                    this.showSnackbar("#b71c1c", "Data not available!");
                }
            })
            .catch(error => {
                this.showSnackbar("#b71c1c", "Something went wrong!!!");
            })
            .finally(() => {   
            });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        // editItem(item) {
        //     this.editedIndex = this.course_auth_level.indexOf(item)
        //     this.editedItem = Object.assign({}, item)
        //     this.dialog = true
        // },
        // close() {
        //     this.dialog = false;
        //     setTimeout(() => {
        //         this.editedItem = Object.assign({}, this.defaultItem);
        //         this.editedIndex = -1;
        //     }, 300);
        // },
        updateEmployee(value, authorityid) {
            // this.selested_auth_emp.authid = authorityid;
            // this.selested_auth_emp.empid = value;
            // this.selected_emp.push(this.selested_auth_emp);

            this.selected_emp.push(value);
            this.selected_emp.push(authorityid);
        },

        findprogtype() {
            const data = {
                selected_prog: this.selected_prog
            };
            axios
                .post("/Examination/fetchProgtype", data)
                .then(res => {
                    window.console.log(res);
                    if (res.data.msg == "200") {
                        this.progtype_list = res.data.pt;
                        //this.orglist.name=res.data.org.name
                        document.getElementById("ptdiv").style.display = "block";
                        //this.domainpath=res.data.domainpath
                    } else {
                        this.message = res.data.msg;
                    }
                })
                .catch(error => {
                    window.console.log("error:" + error);
                })
                .finally(() => (this.fetch_org_load = false));
        },
        findsubject() {
            const data = {
                selected_prog: this.selected_prog,
                selected_prog_type: this.selected_prog_type,
                year_data: this.year_data,
            };
            axios
                .post("/Examination/fetchSubjectData", data)
                .then(res => {
                    window.console.log(res);
                    if (res.data.msg == "200") {
                        this.sub_list = res.data.sub;
                        //this.orglist.name=res.data.org.name
                        document.getElementById("subdiv").style.display = "block";
                        //this.domainpath=res.data.domainpath
                    } else {
                        this.message = res.data.msg;
                    }
                })
                .catch(error => {
                    window.console.log("error:" + error);
                })
                .finally(() => (this.fetch_org_load = false));
        },
        findsubjectauthority() {
            this.flag_for_radio_group=false
            const data = {
                selected_prog: this.selected_prog,
                selected_prog_type: this.selected_prog_type,
                year_data: this.year_data,
                selected_subject: this.selected_subject
            };
            axios
                .post("/Examination/fetchquestionbank", data)
                .then(res => {
                    window.console.log(res);
                    if (res.data.msg == "200") {
                        this.authority_data = res.data.auth_data;
                        this.auth_inst_data = res.data.auth_data;
                        this.booleanval = res.data.booleanval
                        //this.selected_employee = res.data.auth_data,
                        //this.orglist.name=res.data.org.name
                        //document.getElementById("subdiv").style.display = "block";
                        this.instructor_list = res.data.instructor_data
                    } else {
                        this.message = res.data.msg;
                    }
                })
                .catch(error => {
                    window.console.log("error:" + error);
                })
                .finally(() => (this.fetch_org_load = false));
        },
        getallrecords(value) {
            console.log("value: "+value)
            if(value =='selected_all'){
                this.selected_all = true
            }
            else if(value =='selected_notapproved'){
                this.selected_notapproved = true
            }
            else if(value =='selected_approved'){
                this.selected_approved = true
            }
            const data = {
                selected_all: this.selected_all,
                selected_notapproved: this.selected_notapproved,
                selected_approved: this.selected_approved
            };
            axios
                .post("/Examination/getallrecords", data)
                .then(res => {
                    if (res.data.msg == "200") {
                        this.auth_inst_data = res.data.auth_data;
                        this.selected_notapproved = false;
                        this.selected_approved = false;
                        this.selected_all = false;
                        this.show_detail = false
                    } else {
                        this.message = res.data.msg;
                    }
                })
                .catch(error => {
                    window.console.log("error:" + error);
                })
                .finally(() => (this.fetch_org_load = false));
        },
        getdetails(au) {
            //alert("getdetails::"+au)
            this.dialog = true
            const data = {
                details_id: au
            };
            axios
                .post("/Examination/getdetails", data)
                .then(res => {
                    window.console.log(res);
                    if (res.data.msg == "200") {
                        this.courseauthority = res.data.courseauthority;
                        this.courseauthoritylevels = res.data.courseauthoritylevels;
                        this.instructor_data = res.data.prev_inst_data,
                        this.show_detail = true
                        //alert('success');
                    } else {
                        this.message = res.data.msg;
                    }
                })
                .catch(error => {
                    window.console.log("error:" + error);
                })
                .finally(() => (this.fetch_org_load = false));
        }
    },

    mounted() {
        axios
            .post("/Examination/questiobankstatushome")
            .then(res => {
                this.org = res.data.org_list
                this.progt_list = res.data.porgtype_list
                this.year_list = res.data.year_list
                this.course_auth_level = res.data.course_auth_level_data
                this.auth_levels = res.data.auth_levels
                this.authlevelname = res.data.auth_levels
                this.headers = res.data.headers
                //this.auth_inst_data = res.data.auth_data
                this.booleanval = res.data.booleanval
                // this.dummyyearlist = res.data.year_list
                console.log('prog_list', this.progt_list)
                //this.showSnackbar("#4CAF50","Success")
            })
            .catch(error => {
                this.showSnackbar("#b71c1c", "Something went wrong!!!");
            })
            .finally(() => {

            });
        axios
            .post("/Examination/fetchquestionbank", data)
            .then(res => {
                window.console.log(res);
                if (res.data.msg == "200") {
                    this.authority_data = res.data.auth_data;
                    this.auth_inst_data = res.data.auth_data
                    //this.selected_employee = res.data.auth_data,
                    //this.orglist.name=res.data.org.name
                    //document.getElementById("subdiv").style.display = "block";
                    this.instructor_list = res.data.instructor_data
                } else {
                    this.message = res.data.msg;
                }
            })
            .catch(error => {
                window.console.log("error:" + error);
            })
    }
};
</script>
<style scoped>
.box {
	background-color: #add8e630;
	margin: 8px;
	padding: 8px;
}

.select >>> .v-input__slot {
	background: white !important;
	border-color: hsla(190, 99%, 30%, 1) !important;
}

.main {
	border: 2px solid hsla(190, 99%, 30%, 1) !important;
}

.select >>> .v-select .dropdown-toggle {
	border: none;
}

.h-text {
	background-color: hsla(190, 99%, 30%, 1) !important;
	color: white;
	font-size: 20px;
	font-weight: normal;
	padding: 10px;
}

.card {
	border: 2px solid hsla(190, 99%, 30%, 1) !important;
    border-radius: 0;
}

.v-data-table thead {
	background-color: hsla(190, 99%, 30%, 1) !important;
}
.v-data-table tbody tr td{
border: none !important;
}
.theme--light.v-data-table thead tr th {
	color: white;
	font-size: 20px;
	font-weight: normal;
}
.chip {
	border: 1px solid;
	margin: 15px;
	/* border-radius: 20px; */
	padding-left: 8px;
}
.authlevel {
	font-weight: bold;
	color: hsla(190, 99%, 30%, 1);
    margin: 0;
}
.inst-info {
	font-size: 15px;
}
th, td {
  border-bottom: 1px solid #ddd;
}
</style>